"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorFallbackPage = exports.ErrorUI = void 0;
var react_1 = __importDefault(require("react"));
var Lab2Wrapper_module_scss_1 = __importDefault(require("./Lab2Wrapper.module.scss"));
var i18n = require('@cdo/locale');
var ErrorUI = function (_a) {
    var message = _a.message;
    return (react_1.default.createElement("div", { id: "page-error-container", className: Lab2Wrapper_module_scss_1.default.pageErrorContainer },
        react_1.default.createElement("div", { id: "page-error", className: Lab2Wrapper_module_scss_1.default.pageError },
            react_1.default.createElement("img", { className: Lab2Wrapper_module_scss_1.default.pageErrorImage, src: "/shared/images/sad-bee-avatar.png", alt: "" }),
            react_1.default.createElement("div", null, i18n.loadingError()),
            message && (react_1.default.createElement("div", { className: Lab2Wrapper_module_scss_1.default.pageErrorMessage },
                "(",
                message,
                ")")))));
};
exports.ErrorUI = ErrorUI;
var ErrorFallbackPage = function () { return (react_1.default.createElement("div", { id: "lab-container", className: Lab2Wrapper_module_scss_1.default.labContainer },
    react_1.default.createElement(exports.ErrorUI, null))); };
exports.ErrorFallbackPage = ErrorFallbackPage;
